const routes = [
  {
    index: true,
    label: 'Joseph Karanja',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Leadership',
    path: '/leadership',
  },
  {
    label: 'Conferences & Media',
    path: '/conferences',
  },
  {
    label: 'Honors',
    path: '/honors',
  },
  {
    label: 'Courses Taught',
    path: '/courses',
  },
  {
    label: 'Research',
    path: '/research',
  },
];

export default routes;
